import { apiUrl } from "utils/apiUrl";
import { getPaymentApiOrigin } from "utils/paymentApiUrl";

let cached = null;

export async function loadPaymentConfig() {
  if (cached) return cached;
  try {
    const res = await fetch(apiUrl("/api/public/payment-config"), {
      cache: "no-store",
    });
    const data = await res.json().catch(() => ({}));
    if (res.ok && data.ok) {
      const buildOrigin = getPaymentApiOrigin();
      cached = {
        ...data,
        paymentApiBaseUrl:
          buildOrigin || data.paymentApiBaseUrl || null,
      };
      return cached;
    }
  } catch {
    /* ignore */
  }
  cached = {
    ok: true,
    provider: "plisio",
    providerLabel: "Checkout",
    mock: false,
    slotPaymentEndpoint: "/api/client/slot-payment",
    paymentApiBaseUrl: getPaymentApiOrigin() || null,
    networks: ["USDT BEP20 (BSC)"],
    plisioCurrency: "USDT_BSC",
  };
  return cached;
}

export function clearPaymentConfigCache() {
  cached = null;
}
